import {Step} from 'react-joyride';
import {tourText} from '../../texts/microlessonsListText';
import {stepConfig} from './microlessonsListStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getMicrolessonsListSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Microlessons');
